import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { StickyFooter } from 'foundations-components/transitional/components/StickyFooter';
import { getPortalId } from 'MeetingsLib/selectors/authSelectors';
import { shouldLoadComplianceScript } from './utils/utils';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Cookie Settings Link Component
 *
 * Renders the "Manage Cookies" link container that the HubSpot compliance script
 * will populate with the actual link text and click handler.
 *
 * The compliance script searches for elements with the class
 * '.hs-footer-cookie-settings' and:
 * 1. Removes the 'hidden' attribute
 * 2. Adds link text
 * 3. Attaches a click event listener to open the manage cookies modal
 *
 * This component only renders for portal 53 and handles re-mounting the link
 * when the component re-renders.
 *
 * @see https://docs.google.com/document/d/1lyVQHtnVWiuCxdRz5BiA9MwpQOh9Kz22lYLKAznNn8c
 */
const CookieSettingsLink = ({
  includeFooterWrapper
}) => {
  const portalId = useSelector(getPortalId);
  const shouldLoadScript = shouldLoadComplianceScript(portalId);
  useEffect(() => {
    if (!shouldLoadScript) {
      return;
    }
    try {
      var _win$_hsg;
      // Remount footer link on re-render
      const hiddenFooterCookieSettings = document.querySelector('.hs-footer-cookie-settings[hidden]');
      const win = window;
      if (hiddenFooterCookieSettings && (_win$_hsg = win._hsg) !== null && _win$_hsg !== void 0 && _win$_hsg.compliance) {
        win._hsg.compliance.addSettingsLink();
      }
    } catch (error) {
      console.error('Error adding compliance settings link: ', error);
    }
  }, [portalId, shouldLoadScript]);
  const renderedCookieSettingsLink = useMemo(() => {
    return /*#__PURE__*/_jsx("li", {
      className: "hs-footer-cookie-settings",
      hidden: true,
      children: /*#__PURE__*/_jsx("a", {
        href: ""
      })
    });
  }, []);
  if (!shouldLoadScript) {
    return null;
  }
  return includeFooterWrapper ? /*#__PURE__*/_jsx(StickyFooter, {
    children: renderedCookieSettingsLink
  }) : renderedCookieSettingsLink;
};
export default CookieSettingsLink;